import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { AbstractControl, ControlContainer, FormControl, FormGroupDirective } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, startWith } from 'rxjs';
import { DictionaryItem } from 'src/app/models/dictionary-item';
import { DisableErrorStateMatcher } from 'src/app/shared/error-state-matchers/disable-error-state-matcher';
import { autocompleteValidator } from 'src/app/shared/validators/autocomplete.validator';
import { SubSink } from 'SubSink';

@Component({
  selector: 'app-autocomplete-filter',
  templateUrl: './autocomplete-filter.component.html',
  styleUrl: './autocomplete-filter.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ],
  standalone: false
})
export class AutocompleteFilterComponent implements OnInit, OnDestroy {
  formGroupDirective = inject(FormGroupDirective);

  @Input() name: string;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() debounceTime?: number = 500;
  @Input() datasource: DictionaryItem[];
  @Input() changeCallback: (id: number) => void;
  @Input() searchTextChangeCallback: (value: string) => void;
  @Input() description?: string;

  public readonly matcher = new DisableErrorStateMatcher();
  public readonly inputControl = new FormControl(null, [autocompleteValidator]);
  private readonly subs = new SubSink();

  private get control(): AbstractControl {
    return this.formGroupDirective.form.get(this.name);
  }
  private get objControl(): AbstractControl {
    return this.formGroupDirective.form.get(`${this.name}Object`);
  }


  constructor() {
  }

  ngOnInit(): void {
    this.addControl();

    this.subs.sink = this.inputControl.valueChanges.pipe(
      filter(value => value?.Id))
      .subscribe(value => {
        this.objControl.setValue(value, { emitEvent: false });
        this.control.setValue(value.Id, { emitEvent: true });

        if (this.changeCallback) {
          this.changeCallback(value.id);
        }
      });

    this.subs.sink = this.inputControl.valueChanges.pipe(
      debounceTime(this.debounceTime),
      filter(value => typeof value === 'string'),
      filter(_ => !!this.searchTextChangeCallback)
    ).subscribe(value => this.searchTextChangeCallback(value));

    this.subs.sink = this.objControl?.valueChanges.pipe(
      startWith(this.objControl.value))
      .subscribe(value => {
        this.inputControl.setValue(value, { emitEvent: false });
      });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.removeControl();
  }

  public displayValueFn(value: DictionaryItem): string | undefined {
    return value?.Name;
  }

  private addControl(): void {
    this.formGroupDirective.form.addControl(this.name, new FormControl(null), { emitEvent: false });
    this.formGroupDirective.form.addControl(`${this.name}Object`, new FormControl(null), { emitEvent: false });
  }

  private removeControl(): void {
    this.formGroupDirective.form.removeControl(this.name, { emitEvent: false });
    this.formGroupDirective.form.removeControl(`${this.name}Object`, { emitEvent: false });
  }
}